import {getRegionPathConfig} from "@/core/utils/helpers/regions/regionUrlHelper";

export const addRegionPathToRoutes = (routes) => {
    const regionPath = getRegionPathConfig();
    if (!regionPath) {
        return routes;
    }

    return routes.map(route => {
        if (route.name !== '404') {
            route.path = '/' + regionPath + route.path;
        }
        return route;
    });
}

export const overrideRouterPush = (router) => {
    const originalRouterPush = router.push;

    router.push = function (options, callback = null) {
        const regionPath = getRegionPathConfig();
        const routerPath = options.path;

        if (regionPath && routerPath) {
            if (!routerPath.startsWith(`/${regionPath}`)) {
                options.path = `/${regionPath}${routerPath}`;
            }
        }

        return originalRouterPush.call(this, ...[options, callback]);
    }
}
